import { supabase } from "@/integrations/supabase/client";
import { downloadDocument } from "@/lib/documentDownload";
import { downloadFileName } from "@/components/workflows/docProvenance";

/**
 * Fetch a generated_documents row by id (subject to RLS) and trigger a
 * browser download using a freshly minted signed URL. Prefers the signed
 * PDF when a signed_file_path exists.
 */
export async function downloadDocumentById(
  id: string,
  opts: { underscoreFilename?: boolean } = {},
): Promise<void> {
  const { data, error } = await supabase
    .from("generated_documents")
    .select("id, document_name, file_path, file_url, signed_file_path, signed_file_url")
    .eq("id", id)
    .maybeSingle();
  if (error) throw new Error(error.message);
  if (!data) throw new Error("This document is not available.");
  const hasSigned = !!(data.signed_file_path || data.signed_file_url);
  await downloadDocument(data as any, {
    signed: hasSigned,
    filename: opts.underscoreFilename
      ? downloadFileName(data.document_name, hasSigned ? "signed" : "")
      : undefined,
  });
}
